import React from 'react';
import Seo from '../components/common/Seo';
import PageHero from '../components/common/PageHero';
import { contact } from '@/data/contact';
import { seo } from '@/data/seo';

const Privacy = () => {
  return (
    <div className="min-h-screen bg-white pt-20">
      <Seo {...seo.privacy} />
      <PageHero
        eyebrow="Legal"
        title="Privacy Policy"
        description="How MAYAN Technology handles information submitted through this website."
      />
      <section className="py-16">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 space-y-6 text-gray-600 leading-relaxed">
          <p>
            This website is operated by MAYAN Technology in Amman, Jordan. If you send a message through our contact or careers forms, we use the details you provide only to respond to your enquiry.
          </p>
          <p>
            Messages are delivered by email to {contact.email}. We do not sell personal information. Do not include unnecessary sensitive data in a website form.
          </p>
          <p>
            If you would like us to delete correspondence you have sent, email {contact.email} with your request.
          </p>
        </div>
      </section>
    </div>
  );
};

export default Privacy;
